import {motion} from "framer-motion";
import React from "react";

type Props = {

    children?: React.ReactNode,
    isOpen: boolean,
}


const AccordionMotionDiv = ({isOpen, children}: Props) => {
    const variants = {
        hidden: {
            y: -100,
            opacity: 0,
        },
        visible: {
            y: 0,
            opacity: 1,
            transition: {
                type: "spring",
                damping: 10,
                stiffness: 80,
            },
            style: {
                zIndex: 0
            },
        },
    };

    return (
        <motion.div
            initial="hidden"
            animate={isOpen ? "visible" : "hidden"}
            variants={variants}
        >
            {children}
            {/*<div className="filter_motion_div-divider-bar"></div>*/}
        </motion.div>
    );
};

export default AccordionMotionDiv;